import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-conversion-mapping',
  templateUrl: './add-conversion-mapping.component.html',
  styleUrls: ['./add-conversion-mapping.component.css'],
})
export class AddConversionMappingComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  conversionList: any;
  conversionMappingData: any;
  conversionMappingForm!: FormGroup;
  conversionMappingAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  mappingList: any;
  selectOrganization: any;
  conversionProcessData: any;
  selectedConversion: any;
  setIndicatorData: any;
  addEditEndpoint: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveConversionMappingEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService,
    private router: Router
  ) {
    this.conversionMappingData =
      this.modal?.modalService?.config?.initialState?.['conversionMappingData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.isDisabledDropDown = this.modalLabel == 'Review conversion mapping detail' ? true : false;
    this.conversionList = this.conversionMappingData.conversionProcessList;
    this.mappingList = this.conversionMappingData.materialItems;

    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.conversionMappingData.organizationList
    );

    this.organizationList = newOrganizationlist;
    this.indicatorList = this.conversionMappingData.indicatiorList;
    this.organizatioListFunction();
    this.conversionProcessFunction();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.indicatorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.conversionMappingForm = new FormGroup(form);
    this.conversionMappingAddEditForm = this.formBuilder.group({
      material: [this.conversionMappingData.materialId || null, Validators.required],
      conversionProcessName: [
        this.conversionMappingData.conversionProcessId || null,
        Validators.required,
      ],
      organizationName: [null],
    });
    this.setFormData();
  }

  onChange(value: any) {
    this.administratorService.GetMaterialRegions(value.id).subscribe((data: any) => {
      this.conversionProcessData = data.data;
    });
  }

  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.conversionMappingData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async conversionProcessFunction() {
    await this.conversionList.map((item: any) => {
      if (item.id == this.conversionMappingData.conversionProcessId) {
        return (this.selectedConversion = item);
      }
    });
  }

  setFormData() {
    this.conversionMappingAddEditForm.patchValue({
      conversionProcessName: this.selectedConversion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.conversionMappingAddEditForm.controls['conversionProcessName'].value?.name ==
      'Conversion Process'
    ) {
      return;
    }
    if (
      this.conversionMappingAddEditForm.status == 'VALID' &&
      this.conversionMappingForm.status == 'VALID'
    ) {
      const materialPayload = {
        materialId: this.conversionMappingAddEditForm.controls['material'].value,
        conversionProcessId:
          this.conversionMappingAddEditForm.controls['conversionProcessName'].value?.id,
        oldConversionProcessId:
          this.conversionMappingData.oldConversionProcessId ||
          this.conversionMappingAddEditForm.controls['conversionProcessName'].value?.id,
        organizationId:
          this.conversionMappingAddEditForm.controls['organizationName'].value?.name ==
          'All organization'
            ? null
            : this.conversionMappingAddEditForm.controls['organizationName'].value?.id,
      };
      this.saveConversionMappingEvent.emit(materialPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  orgInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
